/** @jsx jsx */

import { Heading, jsx, Paragraph } from "theme-ui"
import { GatsbyImage } from "gatsby-plugin-image"
import { PropTypes } from "prop-types"

import { Layout } from "../components/Layout"
import { BackToTop } from "../components/BackToTop"
import { BottomNav } from "../components/BottomNav"
import { bibliography } from '../data/bibliography';

const EpisodePage = ({ location, pageContext }) => {
  const currentPage = parseInt(location.pathname.slice(1), 10)
  return (
    <Layout currentPage={currentPage} seoProps={{title: `Episode ${currentPage}`}}>
      <div sx={{ maxWidth: ["100vw", "800px", "800px"], mx: "auto" }}>
        {pageContext.images.map((image) => (
          <GatsbyImage
            key={image.alt}
            image={image.imageData}
            alt={image.alt}
          />
        ))}
      </div>
      <BackToTop />
      <BottomNav episodeThumbnails={pageContext.episodeThumbnails} currentPage={currentPage}/>
      <section sx={{ maxWidth: ["100vw", "800px", "800px"], mx: "auto"}}>
        <Heading>Bibliography</Heading>
        {bibliography[currentPage - 1].map((citation, i) => (
          <Paragraph sx={{my: 3}} key={i} dangerouslySetInnerHTML={{ __html: citation }}/>
        ))}
      </section>
    </Layout>
  )
}
EpisodePage.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
  data: PropTypes.shape({
    desktop: PropTypes.shape({
      gatsbyImageData: PropTypes.object,
    }),
    mobilePortrait: PropTypes.shape({
      gatsbyImageData: PropTypes.object,
    }),
  }),
  pageContext: PropTypes.shape({
    images: PropTypes.arrayOf(
      PropTypes.shape({
        alt: PropTypes.string,
        imageData: PropTypes.object,
      })
    ),
    episodeThumbnails: PropTypes.arrayOf(
      PropTypes.shape({
        episodeNumber: PropTypes.number,
        imageData: PropTypes.object,
      })
    ),
  }),
}

export default EpisodePage
